import React, { useContext } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { api, BusDefect, BusDefectAssessmentType, BusDefectRepairStatusType, BusDefectSeverityType } from "../../../logic/api";
import DropDownField, { IDropDownListItem } from "../../../components/editable/EditableField/fields/DropDownField";
import flex from "../../../styles/flex";
import { useTranslation } from "react-i18next";
import TextInputField from "../../../components/editable/EditableField/fields/TextInputField";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { ProgressDialog } from "../../../components/notifications/progressDialog/progressDialog";
import { SessionContext } from "../../../utility/useSession";


export const WaDefectManageDialog: React.FC<{
    defect: BusDefect;
    show: boolean;
    onClose: (didUpdate: boolean) => void;
}> = (props) => {
    const { t } = useTranslation();
    const [defect, setDefect] = React.useState<BusDefect>(props.defect);
    const [desc, setDesc] = React.useState<string>("");
    const updateDefect = api.hooks.walkaroundDefect.updateDefect();

    React.useEffect(() => {
        setDefect(props.defect);
        setDesc("");
    }, [props.defect]);

    const session = useContext(SessionContext);
    const submit = async () => {
        updateDefect.send(session.current.context, {
            defectId: defect.id!,
            assessment: defect.assessment,
            severity: defect.severity,
            repair: defect.repair,
            notes: desc
        }, (v) => {
            if (v != null) props.onClose(true);
        });
    };

    return (
        <Dialog open={props.show} onClose={() => props.onClose(true)}>
            <DialogTitle>{t("walkarounds.manageDefectTitle")}</DialogTitle>
            <DialogContent>
                <ErrorDialog err={updateDefect.err} />
                <ProgressDialog status={updateDefect.status} />
                <div style={flex.flexRows}>
                    <div style={flex.flexFill}>
                        <DropDownField
                            minWidth={180}
                            readOnly={false}
                            label={t("walkarounds.busAssesmentStatus")}
                            selectedItem={
                                {
                                    name: "",
                                    value: `${defect.assessment ?? 0}`,
                                }
                            }
                            onRequestData={async () => {
                                const items: IDropDownListItem[] = [];
                                for (const k in BusDefectAssessmentType) {
                                    if (!isNaN(parseInt(k))) continue;
                                    items.push({
                                        name: t(`walkarounds.busAssesmentStatusTypes.${k.toString()}`),
                                        value: BusDefectAssessmentType[k],
                                    });
                                }
                                return items;
                            }}
                            onChange={(value) => {
                                let selectedValue = parseInt(`${value.value}`);
                                if (isNaN(selectedValue)) selectedValue = 0;
                                setDefect({
                                    ...defect,
                                    assessment: selectedValue,
                                });
                            }}
                        ></DropDownField>
                    </div>
                    <div style={{ width: 20 }}></div>
                    <div style={flex.flexFill}>
                        <DropDownField
                            minWidth={180}
                            readOnly={false}
                            label={t("walkarounds.busSeverityStatus")}
                            selectedItem={
                                {
                                    name: "",
                                    value: `${defect.severity ?? 0}`,
                                }
                            }
                            onRequestData={async () => {
                                const items: IDropDownListItem[] = [];
                                for (const k in BusDefectSeverityType) {
                                    if (!isNaN(parseInt(k))) continue;
                                    items.push({
                                        name: t(`walkarounds.busSeverityStatusTypes.${k.toString()}`),
                                        value: BusDefectSeverityType[k],
                                    });
                                }
                                return items;
                            }}
                            onChange={(value) => {
                                let selectedValue = parseInt(`${value.value}`);
                                if (isNaN(selectedValue)) selectedValue = 0;
                                setDefect({
                                    ...defect,
                                    severity: selectedValue,
                                });
                            }}
                        ></DropDownField>
                    </div>
                    <div style={{ width: 20 }}></div>
                    <div style={flex.flexFill}>
                        <DropDownField
                            minWidth={180}
                            readOnly={false}
                            label={t("walkarounds.busRepairStatus")}
                            selectedItem={
                                {
                                    name: "",
                                    value: `${defect.repair ?? 0}`,
                                }
                            }
                            onRequestData={async () => {
                                const items: IDropDownListItem[] = [];
                                for (const k in BusDefectRepairStatusType) {
                                    if (!isNaN(parseInt(k))) continue;
                                    items.push({
                                        name: t(`walkarounds.busRepairStatusTypes.${k.toString()}`),
                                        value: BusDefectRepairStatusType[k],
                                    });
                                }
                                return items;
                            }}
                            onChange={(value) => {
                                let selectedValue = parseInt(`${value.value}`);
                                if (isNaN(selectedValue)) selectedValue = 0;
                                setDefect({
                                    ...defect,
                                    repair: selectedValue,
                                });
                            }}
                        ></DropDownField>
                    </div>
                </div>
                <div style={{ height: 20 }}></div>
                <TextInputField
                    maxWidth={550}
                    height={150}
                    label={t("walkarounds.defectNotes")}
                    value={desc}
                    onChange={(val) => { setDesc(val) }}
                    multiLine={true}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.onClose(false)}>{t("walkarounds.defectClose")}</Button>
                <Button onClick={() => submit()}>{t("walkarounds.defectSave")}</Button>

            </DialogActions>
        </Dialog>
    );
};